import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextSize"><Path d="M9 4V6H15V21H17V6H23V4H9Z" fill="currentColor"/><Path d="M7.927 21V12H13V10H1V12H5.927V21H7.927Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextSize;
